<template>
    <div class="item">
        <div class="item-info"
             @click="goProduct">
            <Avatar :icon="icon" :large="false" class="avatar" />
            <div class="text">
                <div class="name" @click="goProduct">{{ value.name }}</div>
                <div class="type">{{ type.name }}</div>
            </div>
        </div>
        <button class="iconed action no-border" @click="unsubscribing">
            <IconCloseSmall />
        </button>
        <TooltipOld bind-to=".action"
                 class="tooltip"
                 trigger-on="hover">
            Отписаться от обновлений
        </TooltipOld>
    </div>
</template>

<script>
import Avatar from '../../Avatar/Avatar.vue';

export default {
    name: 'CardSubscription',
    components: {
        Avatar,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        productTypesMap: {
            type: Object,
            default: () => null,
        },
    },
    computed: {
        type() {
            return this.productTypesMap[this.value.type] ?? {};
        },
        icon() {
            return this.type.icon;
        },
    },
    methods: {
        async unsubscribing() {
            this.$emit('unsubscribing', this.value);
        },
        goProduct() {
            this.$router.push({
                name: 'product',
                params: {
                    id: this.value.id,
                },
            });
            this.$emit('closeModal');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@dsee/mixins.scss';

.item {
    display: flex;
    align-items: center;
    margin: 20px 0;
    padding: 0 32px;

    .item-info {
        display: flex;
        align-items: center;
        cursor: pointer;
        width: 100%;
    }

    .text {
        margin-left: 12px;
        max-width: 337px;
        width: 100%;
    }

    .name {
        font-weight: 500;
        font-size: 16px;
        line-height: 22px;
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .type {
        font-size: 12px;
        line-height: 16px;
        color: rgba(16, 24, 40, 0.6);
    }

    .action {
        display: none;
        margin: auto;
    }

    &:hover .action {
        display: inherit;
    }
}

.tooltip {
    color: #ffffff;
}
</style>
